/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { RequestExtensionStore } from '../stores/requestExtensionStore';

export const useRequestExtensionForm = () => {
  const { requestExtensionStore } = useContext<{ requestExtensionStore: RequestExtensionStore }>(StoreContext);

  return {
    requestExtensionStore,
  };
};
